module.exports = __webpack_public_path__ + "img/img_icon_41.dabf506f.png";